import React from 'react'
import HeroTwo from '../components/heroTwo/HeroTwo'
import './blog1.css'
import img from '../assets/boy.jpg'
import arrow from '../assets/arrow.svg'
import { Link } from 'react-router-dom'
function Blog1() {
    return (
        <div className='blog__container'>
        <HeroTwo 
        head='Blog 1'
        />
        <div className="main__blog">
            <div className="main__img">
            <Link className="paragraph" to='/blog' >
                 <img src={arrow} alt="" />
                  Back to Blog page
            </Link>
            </div>
            <div className="body__blog">
                    <div className="blog__img">
                        <img src={img} alt="" />
                    </div>
                    
                <div className="text__blog">

                    <h2>WHY SHOULD I INTRODUCE MY CHILD TO COMPUTER PROGRAMMING AT A YOUNG AGE?</h2>
                    <p className='paragraph'>There are numerous reason why your child should start learning coding at an early age.  A few are listed below:
                    </p>
                    <ol>
<li className='paragraph'>1.	Computer Programming helps your child develop computational thinking skills at an early age. Computational thinking (CT) is one of the key 21st century skills and involves understanding a problem, designing a solution and expressing it in a form that a human or a machine can execute.
</li>
<li className='paragraph'>2. Coding enables children think about and analyze their own problems.
</li>
<li className='paragraph'>3.  Children are able to solve their own problems by breaking them into smaller sub problems.
</li>
<li className='paragraph'>4.	Coding helps children improve in other subject areas like mathematics, storytelling and logical reasoning. Many of the abstract topics taught in Mathematics are applied in programming and this helps children understand such topics better.
    </li>
    <li className='paragraph'>5.	Learning at an early age enables children develop skills that can be applied to different fields a child might be interested exploring further in the future. Technology is being applied in nearly all areas of life including Medicine, engineering, sciences, music and arts. 
    </li>
    <li className='paragraph'>6.	It will be easier for children that start acquiring these skills early to transition into other related fields like robotics, Data Science, 3-D printing, mobile app development and Artificial Intelligence (AI)
    </li>
    </ol>
                </div>
                

            </div>
          
            
        </div>

    </div>
    )
}

export default Blog1
